/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Criteria } from './Criteria';
import {
    CriteriaFromJSON,
    CriteriaFromJSONTyped,
    CriteriaToJSON,
} from './Criteria';

/**
 * 
 * @export
 * @interface CriteriaCategory
 */
export interface CriteriaCategory {
    /**
     * 
     * @type {string}
     * @memberof CriteriaCategory
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaCategory
     */
    facility_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaCategory
     */
    name: string;
    /**
     * 
     * @type {Array<Criteria>}
     * @memberof CriteriaCategory
     */
    criteria?: Array<Criteria>;
}

/**
 * Check if a given object implements the CriteriaCategory interface.
 */
export function instanceOfCriteriaCategory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CriteriaCategoryFromJSON(json: any): CriteriaCategory {
    return CriteriaCategoryFromJSONTyped(json, false);
}

export function CriteriaCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'name': json['name'],
        'criteria': !exists(json, 'criteria') ? undefined : ((json['criteria'] as Array<any>).map(CriteriaFromJSON)),
    };
}

export function CriteriaCategoryToJSON(value?: CriteriaCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'name': value.name,
        'criteria': value.criteria === undefined ? undefined : ((value.criteria as Array<any>).map(CriteriaToJSON)),
    };
}

